import { useEffect, useState } from "react";
import { useMsal } from "@azure/msal-react";
import { getTokenClaims } from "../../authConfig";
import { ScrollArea, Stack, Table, Title } from "@mantine/core";

type Claim = {
    name: string;
    value: string;
};

export const TokenClaimsView = () => {
    const { instance } = useMsal();
    const [claims, setClaims] = useState<Claim[]>([]);

    useEffect(() => {
        const fetchClaims = async () => {
            return await getTokenClaims(instance);
        };
        fetchClaims()
            .then(claims => {
                const parsedClaims = createClaims(claims);
                return parsedClaims;
            })
            .then(data => {
                setClaims(data);
            });
    }, []);

    const ToString = (a: string | any) => {
        if (typeof a === "string") {
            return a;
        } else {
            return JSON.stringify(a);
        }
    };

    let createClaims = (o: Record<string, unknown> | undefined) => {
        return Object.keys(o ?? {}).map((key: string) => {
            let originalKey = key;
            try {
                // Some claim names may be a URL to a full schema, just use the last part of the URL in this case
                const url = new URL(key);
                const parts = url.pathname.split("/");
                key = parts[parts.length - 1];
            } catch (error) {
                // Do not parse key if it's not a URL
            }
            return { name: key, value: ToString((o ?? {})[originalKey]) };
        });
    };

    const rows = claims.map(({ name, value }) => (
        <Table.Tr key={name}>
            <Table.Td>{name}</Table.Td>
            <Table.Td>{value}</Table.Td>
        </Table.Tr>
    ));

    return (
        <Stack gap="sm">
            <Title order={6}> Id Token Claims</Title>
            <ScrollArea.Autosize mah="100%">
                <Table variant="vertical">
                    <Table.Tbody>{rows}</Table.Tbody>
                </Table>
            </ScrollArea.Autosize>
        </Stack>
    );
};
